module.exports = __webpack_public_path__ + "img/east-of-nowhere-search.75c422ad.png";